import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SummaryApi } from 'api/SummaryApi';
import { OpinionQuestionApi } from 'api/OpinionQuestionApi';
import { CompareGroupApi } from 'api/CompareGroupApi';
import { OverallSurvey } from 'model/OverallSurvey';

import { OverallSurveyMapper } from '../mapper/OverallSurveyMapper';

export namespace OverallSurveyApi {
  export type EntryCombine = {
    summary: SummaryApi.EntryCombine;
    byCategory: OpinionQuestionApi.CombineEntry[];
    showImpactOnEngagement: boolean;
  };
  export type EntryCompare = {
    summary: SummaryApi.EntryCompare[];
    categories: OpinionQuestionApi.CompareEntry[];
    groups: CompareGroupApi.Entry;
    combineModeLock: boolean;
    protections: { [key: number]: boolean };
  };
}

export class OverallSurveyApi {
  constructor(private client: AxiosInstance, private overallSurveyMapper: OverallSurveyMapper) {}

  combine(
    { projectId, query }: { projectId: number; query: string },
    { signal }: AxiosRequestConfig = {}
  ): Promise<OverallSurvey.Combine | void> {
    return this.client
      .get(`/api/v1/project/${projectId}/report/summary/combined${query}`, { signal })
      .then((response) => this.overallSurveyMapper.deserializeCombine(response.data))
      .catch((error) => {
        if (signal?.aborted === false) {
          throw error.response ? error.response.data.error : error;
        }
      });
  }

  compare(
    { projectId, query }: { projectId: number; query: string },
    { signal }: AxiosRequestConfig = {}
  ): Promise<OverallSurvey.Compare | void> {
    return this.client
      .get(`/api/v1/project/${projectId}/report/summary/compared${query}`, { signal })
      .then((response) => this.overallSurveyMapper.deserializeCompare(response.data))
      .catch((error) => {
        if (signal?.aborted === false) {
          throw error.response ? error.response.data.error : error;
        }
      });
  }
}
